<template>
  <section>
    <div class="modal is-clipped" :class="{'is-active': addCalendarUsers}">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Add Calendar Users</p>
          <button class="delete" aria-label="close" @click="addCalendarUsers=false"></button>
        </header>
        <section class="modal-card-body">
          <div class="content">Select the number of additional calendar users you would like to add</div>

          <div class="field is-grouped is-grouped-centered">
            <span class="select">
              <select v-model="userPurchaseCount">
                <option
                  v-for="option in options"
                  v-bind:value="option.value"
                  :key="option.text"
                >{{ option.text }}</option>
              </select>
            </span>
          </div>
          <button
            class="button is-link"
            @click="checkout(accountSubscriptionType.toLowerCase())"
          >Add Calendar Users</button>
          <p class="help is-danger" v-if="error.payment">Error processing payment. Please try again.</p>
        </section>
      </div>
    </div>
    <vue-stripe-checkout
      ref="checkoutRef"
      :name="name"
      :description="description"
      :currency="currency"
      :amount="amount"
      :allow-remember-me="false"
      :zip-code="true"
      :email="email"
      @done="done"
      @opened="opened"
      @closed="closed"
      @canceled="canceled"
    ></vue-stripe-checkout>
  </section>
</template>

<script>
import Vue from "vue";
import VueStripeCheckout from "vue-stripe-checkout";
import EventBus from "../event-bus";
Vue.use(VueStripeCheckout, process.env.VUE_APP_STRIPE_PUB_KEY);

export default {
  props: {
    accountSubscriptionType: String,
    default: "",
    required: true
  },
  data() {
    return {
      addCalendarUsers: false,
      options: [
        { text: "5 Calendar Users", value: "5" },
        { text: "10 Calendar Users", value: "10" },
        { text: "25 Calendar Users", value: "25" },
        { text: "50 Calendar Users", value: "50" },
        { text: "100 Calendar Users", value: "100" }
      ],
      userPurchaseCount: "5",
      name: "ABALogix LLC",
      description: undefined,
      currency: "usd",
      amount: undefined,
      email: undefined,
      subscriptionType: undefined,
      error: {
        payment: false
      }
    };
  },
  mounted: function() {
    EventBus.$on("displayAddCalendarUsers", eventData => {
      this.addCalendarUsers = eventData;
    });
  },
  methods: {
    checkout(subscriptionType) {
      switch (subscriptionType) {
        case "annual":
          this.subscriptionType = subscriptionType;
          this.amount = 500 * 12 * parseInt(this.userPurchaseCount, 10); //Set for Stripe Checkout display purposes *only*
          this.description = "Annual MileLogix Subscription";
          break;

        case "monthly":
          this.subscriptionType = subscriptionType;
          this.amount = 800 * parseInt(this.userPurchaseCount, 10); //Set for Stripe Checkout display purposes *only*
          this.description = "Monthly MileLogix Subscription";
          break;
      }
      setTimeout(() => this.$refs.checkoutRef.open());
    },
    done({ token }) {
      let stripeTransactionData = {
        token_id: token.id,
        subscription_type: this.subscriptionType,
        calendar_user_quantity: this.userPurchaseCount
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "/calendaruser",
          stripeTransactionData
        )
        .then()
        .catch(function() {
          this.error.payment = true;
        });
    },
    opened() {},
    closed() {},
    canceled() {}
  }
};
</script>

<style scoped>
.select select {
  text-rendering: auto !important;
}
</style>
